var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.417,
    height: 21,
    viewBox: "0 0 18.417 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15955",
    "data-name": "Group 15955",
    transform: "translate(-1174 -573.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27381",
    "data-name": "Path 27381",
    d: "M15.812,189.25c-.962-1.1-2.75-1.65-5.225-1.65H3.712a1.18,1.18,0,0,0-.962.825L0,206.438a.629.629,0,0,0,.55.688H4.812l1.1-6.738v.275a1.18,1.18,0,0,1,.962-.825H8.937c3.987,0,7.012-1.65,7.975-6.188v-.412h0a4.8,4.8,0,0,0-1.1-3.988",
    transform: "translate(1174 385.401)",
    fill: "#263b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27382",
    "data-name": "Path 27382",
    d: "M37.975,220.4h0v.413C37.012,225.488,33.987,227,30,227H27.937a1.179,1.179,0,0,0-.962.825L25.6,236.213a.5.5,0,0,0,.55.55h3.575a.77.77,0,0,0,.825-.687v-.138l.687-4.263V231.4a.77.77,0,0,1,.825-.687h.55c3.437,0,6.187-1.375,6.875-5.5a5.055,5.055,0,0,0-.687-4.125,1.408,1.408,0,0,0-.825-.687",
    transform: "translate(1152.801 357.238)",
    fill: "#139ad6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.f358384db473da13e5e3f0a7a611c561.svg";
export { ForwardRef as ReactComponent };